"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return a css class for the with font awesome icon
 * @param icon The icon class name
 * @param modifiers The modifiers class names
 */
function fa(icon, ...modifiers) {
    return "fa fa-" + [icon, ...modifiers.map(x => "fa-" + x)].join(" ");
}
exports.fa = fa;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/typed-font-awesome/dist/index.js
// module id = 7
// module chunks = 0